/**
 * @file 移籍承認ボタン管理
 */
 'use strict'

 /**
  * @classname BtnApproveTransfer
  * @classdesc 移籍承認ボタン管理
  */
 export default class BtnApproveTransfer {
	 /**
	  * @constructor
	  * @param {jQuery} $e - $('.btn-reject-transfer')
	  */
	 constructor($e, controller) {
		 console.log('BtnApproveTransfer.constructor')
		 this._$e = $e
		 this._controller = controller
		 this.initialize()
	 }
 
 
	 /**
	  * クリックのコールバック
	  *
	  * @memberof BtnApproveTransfer
	  * @return {undefined}
	  */
	 initialize() {
		 console.log(`BtnApproveTransfer.initialize`)
		 console.log(this._$e)
		 this._$e.data('required-element-selectors').split(' ').forEach(selector => {
			 if ($(selector).val() != '') {
				 this._$e
					 .prop('disabled', false)
					 .find('.custom-tooltip')
					 .hide()
			 } else {
				 this._$e
					 .prop('disabled', true)
					 .find('.custom-tooltip')
					 .show()
			 }
		 })
		 this.setEvent()
	 }
 
 
	 /**
	  * イベントをセット
	  *
	  * @memberof BtnApproveTransfer
	  * @return {undefined}
	  */
	 setEvent() {
		 console.log(`BtnApproveTransfer.setEvent`)
		 this._$e.data('required-element-selectors').split(' ').forEach(selector => {
			 $(selector).on('change', () => {
				 if ($(selector).val() != '') {
					 this._$e
						 .prop('disabled', false)
						 .find('.custom-tooltip')
						 .hide()
				 } else {
					 let validity = true
					 this._$e.data('required-element-selectors').split(' ').forEach(selector => {
						 if ($(selector).val() == '') validity = false
					 })
					 if (validity) {
						 this._$e
							 .prop('disabled', false)
							 .find('.custom-tooltip')
							 .hide()
					 } else {
						 this._$e
							 .prop('disabled', true)
							 .find('.custom-tooltip')
							 .show()
					 }
				 }
			 })
		 })
	 }
 }
 